import Tooltip from '../Tooltip/Tooltip'
import classes from './NavItemVertical.module.scss'
import type { ReactNode } from 'react'

// Recieves a render prop and passes its own children back into it.
// This is because the Router can only supply link elements, rather than render props or hooks.

export interface Props {
  children: (content: ReactNode) => ReactNode
  icon: ReactNode
  isCollapsed: boolean
  label: string
}

const NavItemVertical = ({
  isCollapsed,
  children: renderChildrenProp,
  icon,
  label
}: Props) =>
  <span
    className={
      isCollapsed
        ? classes.NavItemVertical + ' ' + classes.isCollapsed
        : classes.NavItemVertical
    }
  >
    {
      renderChildrenProp( // Renders an element that will receive the following elements as children
        <>
          {
            isCollapsed
              ? (
                <Tooltip label={label}>
                  {icon}
                </Tooltip>
              )
              : icon
          }
          <span className={classes.Label}>
            {label}
          </span>
        </>
      )
    }
  </span>

export default NavItemVertical
